module.exports = __webpack_public_path__ + "static/media/alaa hezz.ea2c524e.png";